<h5 translate>Ticket redaction</h5>
<hr />

<div class="form-group">
    <!-- todo: label is not connected to input, extra div tag, need to check html here -->
    <label translate class="fw-bold" (click)="quillEditor?.focus()">Text redaction</label>
    <p translate>Enter the string of text you want to redact from the ticket</p>
    <div class="position-relative">
        <quill-editor
            id="redact-ticket-editor"
            [(ngModel)]="textToRedactModel"
            (onContentChanged)="onTextChanged($event)"
            [modules]="quillConfig"
            (onEditorCreated)="onEditorCreated($event)"
            placeholder="{{ 'Write a text to redact' | translate }}"
            format="text">
        </quill-editor>
    </div>
</div>
<hr />

<div class="form-group" [hidden]="isAttachmentsLoaded">
    <button
        type="button"
        class="btn btn-default big-btn"
        (click)="loadAttachments()"
        [disabled]="isLoading || isSaving"
        translate>
        Load attachments to redact
    </button>
</div>

@if (isLoading) {
    <sb-loader></sb-loader>
}

@if (isAttachmentsLoaded) {
    <div>
        @if (attachmentsData && !(hasInlineImages || hasAttachments)) {
            <div class="form-group" translate>There are no attachments to redact from the ticket</div>
        }

        @if (hasInlineImages) {
            <div class="form-group">
                <!-- todo: label is not connected to input, extra div tag, need to check html here -->
                <label translate class="fw-bold">Inline images</label>

                @if (attachmentsData.inlineImages.length > 1) {
                    <div>
                        <label class="checkbox__label checkbox__label--size-small" for="selectAll">
                            <span translate>Select all images</span>
                            <input
                                type="checkbox"
                                name="selectAll"
                                id="selectAll"
                                [(ngModel)]="isAllInlineAttachmentsSelected"
                                (ngModelChange)="toggleSelectAll($event, 'inlineImages')" />
                            <span class="checkbox__checkmark"></span>
                        </label>

                        <hr />
                    </div>
                }

                <div class="scrolled-container">
                    @for (attachment of attachmentsData.inlineImages; track attachment; let idx = $index) {
                        <div class="attachment-element">
                            <label
                                class="checkbox__label checkbox__label--size-small"
                                for="{{ 'ticketInlineAttachment_' + idx }}">
                                <div class="inline-image-preview" [innerHTML]="attachment.html | safeHtml"></div>
                                <input
                                    type="checkbox"
                                    name="{{ 'ticketInlineAttachment_' + idx }}"
                                    id="{{ 'ticketInlineAttachment_' + idx }}"
                                    [(ngModel)]="attachment.isMarked"
                                    (ngModelChange)="selectAttachment(true)" />
                                <span class="checkbox__checkmark"></span>
                            </label>
                        </div>
                    }
                </div>
            </div>
        }

        @if (hasInlineImages && hasAttachments) {
            <hr />
        }

        @if (hasAttachments) {
            <div class="form-group">
                <!-- todo: label is not connected to input, extra div tag, need to check html here -->
                <label translate class="fw-bold">Attachments</label>

                @if (attachmentsData.attachments.length > 1) {
                    <div>
                        <label class="checkbox__label checkbox__label--size-small" for="selectAllAttachments">
                            <span translate>Select all attachments</span>
                            <input
                                type="checkbox"
                                name="selectAllAttachments"
                                id="selectAllAttachments"
                                [(ngModel)]="isAllAttachmentsSelected"
                                (ngModelChange)="toggleSelectAll($event, 'attachments')" />
                            <span class="checkbox__checkmark"></span>
                        </label>
                        <hr />
                    </div>
                }

                <div class="scrolled-container">
                    @for (attachment of attachmentsData.attachments; track attachment; let idx = $index) {
                        <div class="attachment-element">
                            <label
                                class="checkbox__label checkbox__label--size-small"
                                for="{{ 'ticketAttachment_' + idx }}">
                                <div class="d-flex align-items-center">
                                    <sb-file-preview
                                        [attachment]="attachment"
                                        [attachments]="attachmentsData.attachments"
                                        (click)="preventSelectItem($event)"
                                        [isOnlyPreviewIcon]="true"
                                        [fileIndex]="idx">
                                    </sb-file-preview>
                                    <span class="attachment-name">{{ attachment.name }}</span>
                                </div>

                                <input
                                    type="checkbox"
                                    name="{{ 'ticketAttachment_' + idx }}"
                                    id="{{ 'ticketAttachment_' + idx }}"
                                    [(ngModel)]="attachment.isMarked"
                                    (ngModelChange)="selectAttachment(false)" />
                                <span class="checkbox__checkmark"></span>
                            </label>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}

<div class="buttons-row">
    <button type="button" class="btn btn-default" (click)="closePanel()" translate>Cancel</button>
    <button
        type="button"
        class="btn btn-primary ms-2"
        (click)="confirmRedact()"
        [disabled]="
            isSaving ||
            !((textToRedact && textToRedact.trim() && textToRedact.trim().length > 2) || isSomeAttachmentsSelected)
        "
        translate>
        Redact
    </button>
</div>
